import { render, staticRenderFns } from "./ChildTaskPane.vue?vue&type=template&id=6e7b92c8&scoped=true"
import script from "./ChildTaskPane.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChildTaskPane.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7b92c8",
  null
  
)

export default component.exports